module.exports = __webpack_public_path__ + "static/media/logo-jurema.f20e64c5.png";